// @flow
import v4 from 'uuid/v4';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdAdd } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import * as selectors from '../../reducers';
import GeneralRouteInfoCardContent from '../GeneralRouteInfoCardContent';
import RouteStopsCardContent from '../RouteStopsCardContent';
import OpenButton from '../OpenButton';
import Card from '../Card';
import SearchAddressPopup from '../SearchAddressPopup';
import * as mapActions from '../../actions/map';
import * as routesActions from '../../actions/routes';

import styles from './routeCard.css';
import { Search } from '../CommonTexts';


type PLACE_TYPE = {
  geometry: {
    location: {
      lat: Function,
      lng: Function
    }
  }
};

type RouteCardDummyPropTypes = {
  id: number,
  isShowingStopsDetail?: boolean,
  onPlaceSelected?: PLACE_TYPE => mixed
};

const RouteCardDummy = ({
  id,
  isShowingStopsDetail = false,
  onPlaceSelected,
  ...props
}: RouteCardDummyPropTypes) => (
  <Fragment>
    <Card className={styles.routeCard} isRound {...props}>
      {
        !isShowingStopsDetail
          ? (
            <GeneralRouteInfoCardContent id={id} {...props} />
          ) : <RouteStopsCardContent id={id} {...props} />
      }
    </Card>
    {
      isShowingStopsDetail
        && (
          <div className={styles.buttonContainer}>
            <OpenButton
              id="searchAddressPopup"
              title={i18n.t('labels.stops')}
              Icon={MdAdd}
              tint="primary"
              elevation={2}
              isFullWidth
            />
            <SearchAddressPopup
              id="searchAddressPopup"
              label={Search(i18n.t('common.referenceOrAddress'), 1)}
              onPlaceSelected={onPlaceSelected}
              searchOptions={{ componentRestrictions: { country: 'gt' } }}
            />
          </div>
        )
    }
  </Fragment>
);

const RouteCard = connect(
  (state, { id }) => ({
    id,
    isShowingStopsDetail: selectors.isRouteWatchingStops(state, id),
    currentRoute: selectors.getCurrentRoute(state),
  }),
  dispatch => ({
    onPlaceSelected(place, currentRoute) {
      const {
        geometry: {
          location: { lat, lng },
        },
        formatted_address,
        name,
      } = place;

      const latitude = lat();
      const longitude = lng();

      // Center the map on the new position
      dispatch(mapActions.setMapPosition(
        15,
        longitude,
        latitude,
        true,
        { longitude: -0.5, latitude: 0.50 },
      ));

      // Add new routestop
      dispatch(routesActions.addRouteStop({
        id: v4(),
        stop_type: 'standard',
        name,
        short_name: name,
        address: formatted_address,
        point: {
          type: 'Point',
          coordinates: [longitude, latitude],
        },
        students: [],
        route: currentRoute.id,
      }));
    },
  }),
  ({ currentRoute, ...stateProps }, { onPlaceSelected, ...dispatchProps }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onPlaceSelected(place) {
      onPlaceSelected(place, currentRoute);
    },
  }),
)(RouteCardDummy);


export default RouteCard;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteCard/index.jsx